module.exports = __webpack_public_path__ + "img/155756396222.87380c67.png";